<mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"  [expanded]="panelOpenState()" id="main" class="border">
      <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
       <div class="container-fluid" style="background: black;display: flex;align-items: center;justify-content: space-between;">
          
          <h5 class="mb-0 text-white">Reducer Features
          </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
          <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
       </div>
      </mat-expansion-panel-header>

      <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
       <div class="container-fluid"  style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">
          
          <h5 class="mb-0 text-white">Reducer Features
          </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
          <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
       </div>
      </mat-expansion-panel-header>
<div *ngIf="signalStatus==true">
    
    
        <div class="card-body">
            <div class="row" [formGroup]="reducerSelectionForm">
                <div class="col-md-6 col-lg-6 border" style="border-right: none !important;">
                     <!-- First Row -->
                    <div class="row" style="height: 40px; margin-top: 20px;">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group row">
                                    <label for="inputGearOrientation" class="col-md-5 col-sm-5 col-form-label">Gear Orientation</label>
                                    <div class="col-sm-7 col-md-7">
                                    <select class="form-control" id="inputGearOrientation" formControlName="inputGearOrientation" name="inputGearOrientation" #inputGearOrientationDropDown (change)="onGearOrientationChange($event)">
                                        <option [ngValue]="null" selected>--Select--</option>
                                        <option *ngFor="let option of inputGearOrientation" [value]="option.value">{{ option.text }}</option>
                                    </select>
                                    <div *ngIf="formSubmitted && reducerSelectionForm.get('inputGearOrientation')?.hasError('required')" class="text-danger">
                                        Please select an option.
                                      </div>
                                    </div>
                                </div>
                            </div>
                    </div><br>
                     <!-- Second Row -->
                     <div class="row" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputShaftType" class="col-md-5 col-sm-5 col-form-label">Shaft Type</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputShaftType" formControlName="inputShaftType" name="inputShaftType" #inputShaftTypeDropDown (change)="onShaftTypeChange($event)">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputShaftType" [value]="option.value">{{ option.text }}</option>
                                </select>
                                <div *ngIf="formSubmitted && reducerSelectionForm.get('inputShaftType')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div><br>
                    <!-- Third Row -->
                    <div class="row" id="boreDiaTypeRow" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputBoreDia" class="col-md-5 col-sm-5 col-form-label">Bore Diameter</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputBoreDia" formControlName="inputBoreDia" name="inputBoreDia" #inputBoreDiaDropDown (change)="oninputBoreDiaChange($event)">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputBoreDia" [value]="option.boreDia">{{ option.boreDia }}</option>
                                </select>
                                <div *ngIf="formSubmitted && reducerSelectionForm.get('inputBoreDia')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div><br>
                    <!-- Fourth Row -->
                    <div class="row" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputHandAssembly" class="col-md-5 col-sm-5 col-form-label">Hand of Assembly</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputHandAssembly" name="inputHandAssembly" #inputHandAssemblyDropDown (change)="oninputHandAssemblyChange($event)" (click)="onDropdownClick()">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputHandAssembly" [value]="option.value">{{ option.text }}</option>
                                </select>
                                <!-- <div *ngIf="formSubmitted && reducerSelectionForm.get('inputHandAssembly')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div> -->
                                </div>
                            </div>
                        </div>
                    </div><br>
                    
                    

                    

                    
                </div>
                <div class="col-md-6 col-lg-6 border">
                    <!-- Fifth Row -->
                    <div class="row" style="height: 40px;  margin-top: 20px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputMountingPosition" class="col-md-5 col-sm-5 col-form-label">Mounting Position</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputMountingPosition" name="inputMountingPosition" #inputMountingPositionDropDown (change)="oninputMountingPositionChange($event)" (click)="openMountingPosition()">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputMountingPosition" [value]="option.value">{{ option.text }}</option>
                                </select>
                                <!-- <div *ngIf="formSubmitted && reducerSelectionForm.get('inputMountingPosition')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div> -->
                                </div>
                            </div>
                        </div>
                    </div><br>
                    <!-- Sixth Row -->
                    <div class="row" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputMotorAdaptor" class="col-md-5 col-sm-5 col-form-label">Motor Adapter</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputMotorAdaptor" formControlName="inputMotorAdaptor" name="inputMotorAdaptor" #inputMotorAdaptorDropDown (change)="oninputMotorAdaptorChange($event)">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputMotorAdaptor" [value]="option.value">{{ option.text }}</option>
                                </select>
                                <div *ngIf="formSubmitted && reducerSelectionForm.get('inputMotorAdaptor')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div>
                                  <div *ngIf="setStatus=='no'" class="text-danger">
                                    Custom motor adapters available for larger size units.
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div><br>

                    <!-- Seventh Row -->
                    <div class="row" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputMotorFrameSize" class="col-md-5 col-sm-5 col-form-label">Motor Frame Size</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputMotorFrameSize" formControlName="inputMotorFrameSize" name="inputMotorFrameSize" #inputMotorFrameSizeDropDown (change)="oninputMotorFrameSizeChange($event)">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of sortedInputMotorFrameSize" [value]="option.motorFrame">{{ option.motorFrame }}</option>
                                </select>
                                <div *ngIf="formSubmitted && !reducerSelectionForm.get('inputMotorFrameSize')?.disabled && reducerSelectionForm.get('inputMotorFrameSize')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div><br>
                    <!-- Eighth Row -->
                    <div class="row" *ngIf="dutyCycle=='yes' && Series=='HPNOFAN'" style="height: 40px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <label for="inputCoolingFan" class="col-md-5 col-sm-5 col-form-label">Cooling Fan</label>
                                <div class="col-sm-7 col-md-7">
                                <!-- <select class="form-control" id="inputSpeed" name="lstBrand">
                                    <option value="None">--Select--</option>
                                    <option value="s1">&lt; 50 (Less than 50)</option>
                                    <option value="s2">&gt; 50 (More then 50)</option>
                                </select> -->
                                <select class="form-control" id="inputCoolingFan" name="inputCoolingFan" #inputCoolingFanDropDown (change)="oninputCoolingFanChange($event)" (click)="openFanDialog()">
                                    <option [ngValue]="null" selected>--Select--</option>
                                    <option *ngFor="let option of inputCoolingFan" [value]="option">{{ option }}</option>
                                </select>
                                <!-- <div *ngIf="formSubmitted && !reducerSelectionForm.get('inputCoolingFan')?.disabled && reducerSelectionForm.get('inputCoolingFan')?.hasError('required')" class="text-danger">
                                    Please select an option.
                                </div> -->
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group row">
                                <div class="col-lg-6">
                                   
                                </div>
                                <div class="col-lg-6">
                                    <input id="Btn_ReducerSize" type="button" value="Proceed" class="button btn btn-primary w-100 m-1 p-1" style="background-color: #59842b" (click)="reducerButton()">
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    <!-- <button (click)="openPdfDialog('../../../assets/Content/Catalog/Series_B.pdf')">Open PDF 1</button>
<button (click)="openPdfDialog('../../../assets/Content/Catalog/Series_B.pdf')">Open PDF 2</button>
<a href="../../../assets/Content/Catalog/Series_B.pdf">Test</a>
<img src="../../../assets/Content/Catalog/Series_B.jpg" width="100" /> -->
</div>
<div *ngIf="signalStatus==false">
    <h4 style="color: red;">Please proceed from previous step</h4>
   </div>
</mat-expansion-panel>
</mat-accordion>

